import { GOOGLE_API_KEY } from '@/constants/env'

const OFFER_API_ENDPOINT = '/mobile/store/food-offer'
const CART_DISCOUNT_ENDPOINT = '/mobile/store/cart_discount'
const OFFER_BUYX_GETY_ENDPOINT = '/mobile/store/buyXGetYOffer'
const ENDPOINTS = {
  VENDORS: {
    IP_INFO: 'https://ipinfo.io',
    MAP_GEO: ({ lat, lng }: { lat: number; lng: number }) =>
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_API_KEY}`
  },

  LOG_IN: '/mobile/store/v4/login',
  ME_ROLES: '/mobile/store/v4/me/roles',

  ORDERS_PERFORMANCE: `restarant/get/dashboard_data`,
  ORDERS_PERFORMANCE_FILTER: `/site/restarant/get/filter_data`,
  TOGGLE_AVAILABILITY: '/mobile/store/v2/availability',
  FETCH_AVAILABILITY: (store_id: string) =>
    `/mobile/store/v2/availability/${store_id}`,
  GET_STORE_BUSY_STATUS: '/mobile/store/busy_status',
  UPDATE_STORE_BUSY_STATUS: '/mobile/store/busy_status',
  PRODUCTS_STOCKS: 'restarant/get/dash-stock',
  BEST_SELLING: 'restarant/get/mostsaled/food',
  EXPORT_DELIVERED_ORDERS: 'site/restaurant/exportsDeliveredOrder',

  MY_ORDERS: '/mobile/store/v2.1/myOrders',
  MY_ORDERS_2_2: '/mobile/store/v2.2/myOrders',
  MY_ORDERS_HISTORY: '/mobile/store/v2.1/myOrders/history',
  HISTORY_SEARCH: '/mobile/store/v2/myOrders/historySearch',
  ORDER_DETAILS: ({ storeId, orderId }: { storeId: string; orderId: string }) =>
    `/mobile/store/v2.1/${storeId}/order/${orderId}`,
  ORDER_DETAILS_V_3: ({
    storeId,
    orderId
  }: {
    storeId: string
    orderId: string
  }) => `/mobile/store/v3/${storeId}/order/${orderId}`,
  ORDER_BILLINGS: ({
    storeId,
    orderId
  }: {
    storeId: string
    orderId: string
  }) => `/mobile/store/v2/${storeId}/orderBillings/${orderId}`,

  CONFIRM_ALL_ITEMS: `/site/darkstore/set/confirmed-item-order`,
  ACCEPT_ORDER: '/mobile/store/v2.1/acceptOrder',
  CANCEL_ORDER: '/mobile/store/v2.1/rejectOrder',
  UPLOAD_LOGO: '/site/restarant/upload_logo',
  READY_ORDER: '/mobile/store/v2/orderReady',
  RETURN_TO_STOCK_ORDER: ({
    order_id,
    store_id
  }: {
    order_id: string
    store_id: string
  }) => `/mobile/store/${store_id}/order/${order_id}/stock-returns`,

  CATEGORIES: '/site/restarant/get/categories',
  NEW_CATEGORY: 'site/restarant/save/main_cat',
  NEW_SUB_CATEGORY: 'site/restarant/save/sub_cat',
  NEW_CATEGORY_ORDER: '/site/restaurant/category/change',

  NEW_ORDERS_COUNT: 'site/orders/orderlist',

  GET_CITIES: '/site/restarant/getcity',
  GET_SUB_CITIES: '/site/restarant/get/subcity',
  GET_BUSINESS_INFO: '/restarant/get/aboutbusiness_data',
  UPDATE_BUSINESS_INFO: 'restarant/update/info',
  PAYOUT: 'site/restarant/save/bank_info',
  BILLINGDATA: 'site/restarant/billingdata',
  BILLINGCYCLE: '/site/restarant/fetchCycles',

  IMPORT_FOOD_LIST: 'food/importlist',
  GET_FOOD: '/site/restarant/product/load',
  SAVE_FOOD: 'site/restarant/save/food',
  MENU_ITEM: ({ storeId }: { storeId: string }) =>
    `/mobile/store/menu/${storeId}`,
  MENU_LIST: ({ store_id }: { store_id: string }) =>
    `/mobile/store/v2.1/menu/${store_id}`,
  EXTRAS_VISIBILITIY: ({
    id,
    type
  }: {
    id: string
    type: 'addons' | 'base_pack' | 'type_pack'
  }) => `/mobile/store/menu/visibilityExtras/${type}/${id}`,
  EDIT_MENU_ITEM: '/mobile/store/menu/editFood',
  HIDE_MENU_ITEM: '/mobile/store/menu/hideItem',
  SHOW_MENU_ITEM: '/mobile/store/menu/visibleItem',
  UPDATE_MENU_PRICE: '/site/restaurant/food/changePrice',
  UPDATE_TYPE_PACK: '/site/restaurant/typePack/changePrice',

  REJECTION_REASONS: ({ store_id }: { store_id: string }) =>
    `/mobile/store/v2/${store_id}/rejectionReason`,

  ORDERS_PERFORMANCE_OLD: '/mobile/store/performance/orders',
  ORDERS_PERFORMANCE_LATEST: (store_id: string) => `/mobile/store/performance/branch/orders/${store_id}`,
  REVIEWS_PERFORMANCE: '/mobile/store/performance/reviews',
  PREPARATION_TIME_OLD: '/mobile/store/performance/preparation',
  PREPARATION_TIME_LATEST: (store_id: string) => `/mobile/store/performance/branch/preparation/${store_id}`,

  BEST_SELLING_PERFORMANCE: '/mobile/store/performance/bestSelling',
  BRANCH_BEST_SELLING_PERFORMANCE: (store_id: string) => `/mobile/store/performance/branch/bestSelling/${store_id}`,
  REVENUE_PERFORMANCE: '/mobile/store/performance/RevenuePerformance',
  BRANCH_REVENUE_PERFORMANCE: ({ store_id }: { store_id: string }) =>
    `/mobile/store/performance/branch/revenuePerformance/${store_id}`,
  BRANCH_REVIEWS_PERFORMANCE: (store_id: string) => `/mobile/store/performance/branch/reviews/${store_id}`,

  GET_STORE_INFO: '/mobile/store/v2.1/get_store_profile',
  GET_STORE_PROFILE_V31: '/mobile/store/v3.1/get_store_profile',
  EDIT_STORE_INFO: '/mobile/store/v2/edit_store_profile',
  UPLOAD_STORE_PICTURE: '/mobile/store/v2/profile_pic_upload',

  GET_BUSINESS_HOURS: '/mobile/store/v2/businessHours',
  POST_BUSINESS_HOURS: '/mobile/store/v2/setBusinessHours',
  GET_BRANCH_BUSINESS_HOURS: '/mobile/store/branch/businessHours',
  GET_PREPARATION_TIME: '/mobile/store/v2/rangePreparationTime',
  UPDATE_PREPARATION_TIME: '/mobile/store/v2/rangePreparationTime',

  GET_STORE_BRANCHES: '/mobile/store/branch',
  GET_ALL_STORE_BRANCHES: '/mobile/store/branch/availability',
  SET_BRANCH_AVAILABILITY: '/mobile/store/branch/availability',
  GET_BILLING_CYCLES: (storeId: string) =>
    `/mobile/store/v2/BillingPerformance/${storeId}`,
  GET_BILLING_CYCLE_DETAILS: (storeId: string, cycleId: string) =>
    `/mobile/store/v2.1/BillingDetails/${storeId}/${cycleId}`,

  GET_BANK_INFORMATION: (store_id: string) =>
    `/mobile/store/v2/YassirBankInformations/${store_id}`,
  GET_WALLET_TRANSACTIONS: '/mobile/store/wallet/transactions',
  GET_WALLET_TRANSACTION_DETAILS: (transactionId: string) =>
    `/mobile/store/wallet/transactions/${transactionId}/details`,
  GET_WALLET_DETAILS: '/mobile/store/wallet/details',
  REGISTER: '/siteregister',
  SEND_VERIFICATION_EMAIL: '/site/restaurant/send-verification-email',
  VERIFY_EMAIL_OTP: '/site/restaurant/verify-email-code',

  GET_OFFERS: OFFER_API_ENDPOINT,
  DELETE_OFFER: OFFER_API_ENDPOINT,
  SUBMIT_OFFER: OFFER_API_ENDPOINT,

  GET_CART_DISCOUNT: CART_DISCOUNT_ENDPOINT,
  CREAT_CART_DISCOUNT_ENDPOINT: CART_DISCOUNT_ENDPOINT,
  GET_FLAT_DISCOUNT_SUGGESTIONS: '/mobile/store/cart_discount/suggestions',
  DELETE_CART_DISCOUNT_ENDPOINT: (discount_id: string) =>
    `/mobile/store/cart_discount/${discount_id}`,
  EDIT_CART_DISCOUNT_ENDPOINT: (discount_id: string) =>
    `/mobile/store/cart_discount/${discount_id}`,
  UPDATE_CART_DISCOUNT_STATUS_ENDPOINT: `/mobile/store/cart_discount/status`,

  GET_BUYX_GETY_ENDPOINT: OFFER_BUYX_GETY_ENDPOINT,
  DELETE_BUYX_GETY_ENDPOINT: (offerId: string) =>
    `/mobile/store/buyXGetYOffer/${offerId}`,
  UPDATE_BUYX_GETY_ENDPOINT: `/mobile/store/buyXGetYOffer/status`,
  SET_BRANCH_BUSINESS_HOURS: `/mobile/store/branch/setBusinessHours`,
  CREATE_BUYX_GETY_ENDPOINT: OFFER_BUYX_GETY_ENDPOINT,
  EDIT_BUYX_GETY_ENDPOINT: (offerId: string) =>
    `/mobile/store/buyXGetYOffer/${offerId}`,
  EXPORT_ORDERS_PERFORMANCE: '/mobile/store/performance/branch/orders/export',
  GET_CAMPAIGNS: '/mobile/store/campaigns'
}

export default ENDPOINTS
